// == Import npm
import 'bootstrap/dist/css/bootstrap.min.css';
import CookieConsent from "react-cookie-consent";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useHistory
} from 'react-router-dom';

// == Import
import Header from './components/Header';
import Home from './components/Home';
import Footer from './components/Footer';
import Mention from './components/Mention';
import Error404 from './components/404';
import Error403 from './components/403';


// == Composant
const App = () => {

  const history = useHistory();
  const handleDecline = () => {
    history.push('/mentions-légales');
  }

  return (
    <>
      <Header />
      <Switch>
        <Route path="/" exact>
          <Home />
        </Route>
        <Route path="/mentions-légales">
          <Mention />
        </Route>
        <Router path="/acces-refuse">
          <Error403 />
        </Router>
        <Router path="*">
          <Error404 />
        </Router>
      </Switch>
      <Footer />
      <CookieConsent
        location="bottom"
        buttonText="Accepter"
        cookieName="cookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ background:"#4c99d4", color: "#000000"}}
        expires={150}
        enableDeclineButton={true}
        declineButtonText="En savoir plus"
        onDecline={handleDecline}
        declineButtonStyle={{ background:"#d4be3c", color: "#000000"}}
      >
        Ce site web utilise des cookies pour améliorer l'expérience utilisateur
      </CookieConsent>
    </>
  );
};

// == Export
export default App;
